/**
 * Shared utility helpers for all miniapps
 */
const HU_MONTHS = [
    'január', 'február', 'március', 'április', 'május', 'június',
    'július', 'augusztus', 'szeptember', 'október', 'november', 'december',
];
let currentLang = 'hu';
/**
 * Set the language for date formatting.
 * Call this once on app init with the user's lang from backend (e.g. 'hu_HU', 'en_US').
 */
export function setLang(lang) {
    currentLang = (lang || 'hu').toLowerCase();
}
/**
 * Get the current language code (first 2 chars, e.g. 'hu', 'en').
 */
export function getLang() {
    return currentLang.substring(0, 2);
}
function isHu() {
    return currentLang.startsWith('hu');
}
function getMonthName(date) {
    if (isHu())
        return HU_MONTHS[date.getMonth()];
    const locale = currentLang.replace('_', '-');
    return date.toLocaleString(locale, { month: 'long' });
}
/**
 * Format date string.
 * HU output: "2026 február 9. 12:23:34"
 * Other locales: month name from browser Intl API
 * If time is 00:00:00, only date is shown.
 */
export function formatDate(dateStr) {
    if (!dateStr)
        return '';
    // Treat all-zero MySQL dates as empty
    if (/^0000[-/]00[-/]00/.test(dateStr))
        return '';
    try {
        // Date-only strings (YYYY-MM-DD) must be parsed as LOCAL date — new Date('YYYY-MM-DD')
        // parses as UTC midnight, which shows a spurious time part (e.g. 02:00:00) in local time
        const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
        const date = dateOnly
            ? new Date(parseInt(dateOnly[1], 10), parseInt(dateOnly[2], 10) - 1, parseInt(dateOnly[3], 10))
            : new Date(dateStr);
        if (isNaN(date.getTime()))
            return dateStr;
        const year = date.getFullYear();
        const month = getMonthName(date);
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();
        const seconds = date.getSeconds();
        const datePart = `${year} ${month} ${day}.`;
        if (hours === 0 && minutes === 0 && seconds === 0) {
            return datePart;
        }
        const hh = hours.toString().padStart(2, '0');
        const mm = minutes.toString().padStart(2, '0');
        const ss = seconds.toString().padStart(2, '0');
        return `${datePart} ${hh}:${mm}:${ss}`;
    }
    catch {
        return dateStr || '';
    }
}
/**
 * Truncate string to max length with ellipsis
 */
export function truncate(str, maxLength) {
    if (!str)
        return '';
    if (str.length <= maxLength)
        return str;
    return str.slice(0, maxLength) + '...';
}
